import "./CategoryDetailMenuComponent.scss";
import openSideMenu from '../../../../assests/OpenSideMenu.png';
import { SeparatorWhite } from "../../../../components/styled-components";
import { useContext } from "react";
import { AppContext } from "../../../../contexts/appContext";
import { routesMap } from "../../../../routes";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

/**
 * @function CategoryDetailMenuComponent render the menu with the section
 * @returns {JSX.Element}
*/

const CategoryDetailMenuComponent = ({ activeItem, info, isSection }) => {
  const navigate = useNavigate();
  const [openSideMenuState, setOpenSideMenuState] = useState(false);

  const redirecToCategory = (id, sottoVoci) => {
    navigate(`${routesMap.DETAGLIO_CATEGORIA}/${id}`);
    if(sottoVoci && !sottoVoci.length) {
      setOpenSideMenuState(false)
    }
  }

  const redirecToSottoCategory = (id) => {
    navigate( `${routesMap.DETAGLIO_CATEGORIA}/${id}`);
    setOpenSideMenuState(false);
  }

  const { menu } = useContext(AppContext);

  const categorie = () => {
    if (isSection) {
      return menu?.filter(m => m?.tipologia === info?.tipologia)?.map(v => v?.voci);
    } else {
      const tipoLogiaSection = menu?.find(m =>
         m?.voci?.some(a => a.idContenuto === activeItem) ||
         m?.voci?.some(a=> a?.sottoVoci?.some(b => b?.idContenuto === activeItem)))?.tipologia
      return menu?.filter(m => m.tipologia === tipoLogiaSection)?.map(v => v?.voci);
    }
  }

  return (
    <>
      <nav className="navbar it-navscroll-wrapper navbar-expand-lg it-bottom-navscroll it-left-side" >
        <button onClick={() => setOpenSideMenuState(!openSideMenuState)} className="custom-navbar-toggler" type="button" aria-controls="navbarNav" aria-expanded="false" aria-label="Menu di navigazione" data-bs-target="#navbarNav">
          <span className="it-list"></span>
          <img
            src={ openSideMenu }
            alt={ "openSideMenu" }
            width={ 40 }
            height={ 40 }
          />
        </button>
        <div className= {`${openSideMenuState ? "navbar-collapsable expanded" : "navbar-collapsable "}`}  style= {{ display: openSideMenuState ? 'block' : 'none'}} id="navbarNav" tabIndex="-1" role="menu">
          <div className= {`${openSideMenuState ? "overlay fade" : "overlay fade show "}`} style= {{ display: openSideMenuState ? 'block' : 'none'}}></div>
          <div className="close-div visually-hidden">
            <button className="btn close-menu" type="button"><span className="it-close"></span>close
            </button>
          </div>

          <div className="menu-wrapper">
            <a className={`${openSideMenuState ? "it-back-button show" : "it-back-button"}`}  role="button"  onClick={() => setOpenSideMenuState(!openSideMenuState)}>
              <img
                src={ openSideMenu }
                alt={ "closeSideMenu" }
                width={ 40 }
                height={ 40 }
              />
            </a>
            <div className="link-list-wrapper">
              <ul className="link-list">
                {
                  categorie()?.map(item => {
                    return item?.map(sottoItem => {
                      const { nome, idContenuto, sottoVoci } = sottoItem;
                      const isActiveSottoMenu = !!( sottoVoci.find( s => s.idContenuto === activeItem ) )
                      return (
                        <li key={ idContenuto } className={ `nav-item ${ ( idContenuto === activeItem || isActiveSottoMenu ) ? "active" : "" }` }>
                          <a className={ `nav-link  ${ (idContenuto === activeItem || isActiveSottoMenu) ? "active" : "" }` } role="menuitem" tabIndex="0" onClick={ () => redirecToCategory(idContenuto, sottoVoci) }><span>{ nome }</span></a>
                          { sottoVoci.length > 0 && ( idContenuto === activeItem || isActiveSottoMenu ) ? (
                            <>
                              <ul className="link-list link-sublist">
                                {
                                  sottoVoci?.map(sottoVoce => {
                                    const { nome, idContenuto } = sottoVoce;
                                    return (<li key={ idContenuto } className={ `nav-link  ${ idContenuto === activeItem ? "active" : "" }` }>
                                      <a className={ `nav-link  ${ idContenuto === activeItem ? "active" : "" }` } role="menuitem" tabIndex="0" onClick={ () => redirecToSottoCategory(idContenuto) }><span> { nome } </span></a>
                                    </li>);
                                  })
                                }
                              </ul>
                              <SeparatorWhite></SeparatorWhite>
                            </>
                          ) : null }
                        </li>
                      );

                    });
                  })
                }
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

CategoryDetailMenuComponent.defaultProps = {
};

export default CategoryDetailMenuComponent;